export default __webpack_public_path__ + "static/media/logo-health.6d38108d.png";